import React from "react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

interface AddProductCardProps {
  icon?: React.ReactNode
  title: string
  description: string
  onClick: () => void
  variant?: "primary" | "secondary"
  badge?: string
  testId?: string
}

export const AddProductCard: React.FC<AddProductCardProps> = ({
  icon,
  title,
  description,
  onClick,
  variant = "secondary",
  badge,
  testId,
}) => {
  const isPrimary = variant === "primary"

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "group relative flex flex-col items-center gap-3 rounded-lg border-2 p-6 text-center transition-all",
        isPrimary
          ? "border-primary/30 bg-background shadow-sm hover:border-primary hover:shadow-md"
          : "border-transparent bg-muted/50 hover:border-primary/40 hover:bg-muted"
      )}
    >
      {badge ? (
        <Badge
          variant="default"
          className="absolute right-3 top-3 px-2 py-0.5 text-[10px] uppercase tracking-wide shadow-sm"
        >
          {badge}
        </Badge>
      ) : null}
      {icon && (
        <div
          className={cn(
            "flex h-10 w-10 items-center justify-center rounded-lg transition-colors",
            isPrimary
              ? "bg-primary text-primary-foreground"
              : "bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground"
          )}
        >
          {icon}
        </div>
      )}
      <div>
        <p className={cn("font-semibold", isPrimary ? "text-base" : "text-sm")}>{title}</p>
        <p className="mt-1 text-xs text-muted-foreground">{description}</p>
      </div>
    </button>
  )
}
